export default __webpack_public_path__ + "static/media/completed_female.17b0ad99.png";